<template>
    <form action="" method="POST" class="" v-on:submit.prevent="submit()">
        <div class="form-row">
            <div class="form-group col-md-6 text-left">
            <label for="nome">
                Nome
            </label>
            <input v-model="name" v-bind:class="{ error: this.name == '' && submited }" type="text" autofocus="autofocus" class="form-control form-control-lg" required>
            </div>
            <div class="form-group col-md-6 text-left">
            <label for="email">
                email
            </label>
            <input v-model="to" v-bind:class="{ error: this.to == '' && submited }" type="email" autofocus="autofocus" class="form-control form-control-lg" required>
            </div>
            <div class="form-group col-12 text-left">
            <label for="mensagem">
                Mensagem
            </label>
            <textarea v-model="msg" name="mensagem" v-bind:class="{ error: this.msg == '' && submited }"  class="form-control" id="mensagem" rows="5" required></textarea>
            </div>
            <button type="submit" class="btn btn-primary">Enviar</button>
        </div>
    </form>
</template>

<style lang="scss" scoped>
    .error {
        border-color: red;
    }
    input, textarea {
        box-shadow: none;
    }
</style>
    
<script>
    import ApiClient from '../../utils/api-client';

    export default {
        components: { },
        data() {
            return {
                to: "",
                name: "",
                msg: "",
                submited: false
            }
        },
        methods: {
            submit() {
                this.submited = true;

                if(!this.isNullOrEmpty(this.to) &&
                    !this.isNullOrEmpty(this.msg) &&
                    !this.isNullOrEmpty(this.name)) {
                        ApiClient.inviteFriend(this.to, this.msg, this.name) 
                            .then((result) => {
                                if (result.status == 200) {
                                    this.$emit("finished");
                                } else {
                                    this.$emit("finished");
                                }
                            })
                            .catch(() => {

                            });
                    }
            },

            isNullOrEmpty(value) {
                if (value == null || value == '')
                    return true;
                
                return false;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Invite/Friend.vue